<yc-typeahead-select
  [name]="controlName"
  [disabled]="disabled"
  [isLocked]="disabled"
  [items]="budgetFundingSourceOptions"
  [label]="hideFundingSources ?
    ('common:lblBudget' | ycI18n: 'Budget') :
    ('APPLY:lblBudgetAndFundingSource' | ycI18n: 'Budget and funding source')"
  [showClear]="false"
  [placeholder]="'AWARDS:textSelectABudgetFundingSource' | ycI18n: 'Select a budget / funding source'"
  [help]="remainingAmountBudgetMap[comboId]?.helpDisplay"
  [helpTextClass]="(remainingAmountBudgetMap[comboId]?.value < 0) ?
    'text-danger' : 
    ''"
  (onChange)="_onBudgetFsChange()">
  <div *ycTypeaheadTemplate="''; let item;"
    class="d-flex flex-column">
    <span class="white-space-initial"
      [innerHTML]="item.htmlLabel | escapeHtml">
    </span>
    <small class="d-block"
      [class.text-danger]="remainingAmountBudgetMap[
        item.value.comboId
      ]?.value < 0">
      {{ remainingAmountBudgetMap[item.value.comboId]?.label }}
    </small>
  </div>
</yc-typeahead-select>